import React from 'react';

import ErrorScreen from 'components/ErrorScreen/ErrorScreen';

import * as Styled from './NotFound.styles';

const NotFound = () => (
  <Styled.Wrapper>
    <ErrorScreen errorType="404" />
  </Styled.Wrapper>
);

export default NotFound;
